import React, { memo, PropsWithChildren, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsEmbedded } from './selectors/device'
import { useNavigate } from 'react-router-dom'
import LayoutManager from './util/layoutManager'
import ChartManager from './util/chartManager'
import MultistrikeChartManager from './util/multistrikeChartManager'
import EmbeddedDataManager from './util/embeddedDataManager'
import { isEmbeddedModeSet } from './util/general'
import commonActions from './actions/common.actions'
import TradeManager from './util/TradeManger'
import PayoffManager from './util/payoffManager.ts'

if (isEmbeddedModeSet()) {
    window.layoutManager = new LayoutManager()
    window.chartManager = new ChartManager()
    window.multistrikeChartManager = new MultistrikeChartManager()
    window.embeddedDataManager = new EmbeddedDataManager()
    window.tradeManager = new TradeManager()
    window.payoffManager = new PayoffManager()
}

const EmbeddedWrapper: React.FC<PropsWithChildren> = ({ children }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const isEmbedded = useSelector(selectIsEmbedded)

    useEffect(() => {
        if (isEmbedded) {
            if (!window.navigate) {
                window.navigate = navigate
            }

            if (!window.setTheme) {
                window.setTheme = (theme: any) => {
                    commonActions.setThemeMode(dispatch, theme as any)
                }
            }
        }
        return () => {
            window.navigate = undefined
        }
    }, [isEmbedded, navigate])
    return children
}

export default memo(EmbeddedWrapper)
